// extracted by mini-css-extract-plugin
export default {"form":"NovoPedidoBmaFolha_form__BmfCQ","areaBtn":"NovoPedidoBmaFolha_areaBtn__qgqFo","btn":"NovoPedidoBmaFolha_btn__gUdMK","btn2":"NovoPedidoBmaFolha_btn2__bMIgI"};